import { useState } from 'react';

export const useToggle = (defaultValue) => {
	const [value, setValue] = useState(!!defaultValue);

	const on = () => setValue(true);

	const off = () => setValue(false);

	return [value, on, off];
};
